import { render, staticRenderFns } from "./showIntlflight.vue?vue&type=template&id=343d56b4"
import script from "./showIntlflight.vue?vue&type=script&lang=js"
export * from "./showIntlflight.vue?vue&type=script&lang=js"
import style0 from "./showIntlflight.vue?vue&type=style&index=0&id=343d56b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports